(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodListSelector', sodListSelector);

    function sodListSelector() {
        return {
            restrict: 'E',
            templateUrl: 'common/components/sod-list-selector',
            scope: {
                options: '=?',
                validate: '=?',
            },
            require: 'ngModel',
            controller: sodListSelectorCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, elem, attr, ctrl) {
                var vm = scope.vm;
                ctrl.$render = function () {
                    vm.selected_jobs = ctrl.$viewValue;
                }
            }
        };
    }

    function sodListSelectorCtrl(lodash, $element, ActionManager) {
        var ngModel = $element.controller('ngModel');
        var vm = this;

        this.$onInit = function() {

            vm.selected_jobs = [];
            vm.toggled_more_jobs = [];

            vm.toggleMore = toggleMore;
            vm.isToggledMore = isToggledMore;

            vm.toggleSelection = toggleSelection;
            vm.isSelected = isSelected;

            vm.validate = validate;

            $element.find('.validate-message').hide();
        }

        function toggleSelection(item) {

            var filtered = lodash.filter(vm.selected_jobs, function (_item2) {
                return (_item2 == item.id)
            });
            if (filtered.length == 0) {
                if (vm.options.max > vm.selected_jobs.length) {
                    vm.selected_jobs.push(item.id);
                    dataLayerPush({
                        event: 'jobSelected',
                        entity_id: item.select_id,
                        entity_label: item.title,
                    });

                } else {

                    ActionManager('notify', {
                        'template': vm.options.max_warning,
                        'hasDelay': true,
                        'delay': 3000,
                        'type': 'warning',
                        'position': 'bottom right-float'
                    });

                }
            } else {

                vm.selected_jobs = lodash.filter(vm.selected_jobs, function (_item2) {
                    return _item2 != item.id;
                });
                dataLayerPush({
                    event: 'jobUnselected',
                    entity_id: item.select_id,
                    entity_label: item.title,
                });
            }
            ngModel.$setViewValue(vm.selected_jobs);
        }

        function isSelected(item) {
            return vm.selected_jobs.indexOf(item.id) >= 0;
        }

        function toggleMore(item) {
            var filtered = lodash.filter(vm.toggled_more_jobs, function (_item2) {
                return (_item2 == item.id)
            });

            if (filtered.length == 0) {
                vm.toggled_more_jobs = vm.toggled_more_jobs.concat(item.id);
                dataLayerPush({
                    event: 'jobSelectionShowMore',
                    entity_id: item.select_id,
                    entity_label: item.title,
                });
            } else {
                vm.toggled_more_jobs = lodash.without(vm.toggled_more_jobs, item.id);
                dataLayerPush({
                    event: 'jobSelectionShowLess',
                    entity_id: item.select_id,
                    entity_label: item.title,
                });
            }
        }

        function isToggledMore(item) {
            return vm.toggled_more_jobs.indexOf(item.id) >= 0;
        }

        function validate() {
            if (vm.selected_jobs.length < vm.options.min) {
                dataLayerPush(
                    {
                        event: 'validationErrorOccurred',
                        step: 1
                    }
                );
                $element.find('.validate-message').show();
                return false;
            }
            $element.find('.validate-message').hide();
            return true;

        }

        function dataLayerPush(data) {
            return window.dataLayer.push(data);
        }
    }
})();
